import React from 'react';
import UaePassLoginButton from '../ui-components/UaePassLoginButton';

interface Props {
    onSignIn: () => void;
}

const UaePassIdleState: React.FC<Props> = ({ onSignIn }) => {
    return (
        <div className="flex flex-col gap-5">
            <UaePassLoginButton onClick={onSignIn} />
        </div>
    );
};

export default UaePassIdleState;
